module.exports = __webpack_public_path__ + "static/media/chevron-right.b6a25521.svg";